
var         _  = require('lodash')
    ,    Dexie = require('dexie').default    
    ,   models = require('_Models')
    ,  helpers = require('Helpers')
    ,      md5 = require("md5");
    require('dexie-observable');

Dexie.debug = true;

var repository        = new Dexie('fusionGallery0.0.1'),         
    tableDefinitions  = _.mapKeys(models, helpers.formatTableName),
    tableClassStrings = _.mapValues(tableDefinitions, helpers.definitionToString),
    stringified       = JSON.stringify(_(tableClassStrings).toPairs().sortBy(_.head).fromPairs().value() ),
    md5ified          = md5(stringified);

repository.md5 = md5ified;
repository.version(1).stores(tableClassStrings);

_.forIn(tableDefinitions, function (definition,tableName) { repository[tableName].mapToClass(definition) });

module.exports = repository;


